import styled from 'styled-components';
import { CALLER_COLORS as C } from '../tokens';

// Styled-components for the inline "Booking — Order" composer (Figma node 19:4540+).
// Compact card so the composer reads tidy inside the narrow caller panel.

export const OrderCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  padding: 14px;
  background: #fff;
  border: 1px solid ${C.border};
  border-radius: 12px;
`;

export const OrderHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;
export const OrderTitle = styled.div`
  color: ${C.navy};
  font-size: 15px;
  font-weight: 700;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

// Fields laid out in a single row (Staff + Start time + Duration), equal thirds
// so they always fit one line in the narrow panel.
export const FieldRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: flex-start;
  > div {
    flex: 1 1 0;
    min-width: 0;
  }
`;
export const FieldLabel = styled.div`
  color: ${C.slate};
  font-size: 12px;
  font-weight: 600;
`;

// Staff label + "Request Staff" toggle on one line.
export const StaffHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .ant-checkbox-wrapper {
    color: ${C.navy};
    font-size: 13px;
    font-weight: 600;
  }
`;

// Staff / Start-time selector pill — fills its column in the FieldRow.
export const SelectorChip = styled.button`
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  height: 48px;
  background: ${C.lightBtnBg};
  border: 1px solid ${C.border};
  border-radius: 11px;
  padding: 0 16px;
  color: ${C.navy};
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
  > img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
  > img:last-child {
    margin-left: auto;
  }
  .placeholder {
    color: ${C.gray};
  }
`;

// Round staff photo shown inside the Staff selector chip.
export const ChipAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  overflow: hidden;
  flex-shrink: 0;
  background: ${C.avatarBg};
  border: 1px solid rgba(0, 0, 0, 0.06);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ServiceChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`;
// Service chip — same 48px height as the other chips / Add-services button.
export const ServiceChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 48px;
  background: ${C.orangeSoftBg};
  border: 1px solid ${C.accentOrange};
  border-radius: 999px;
  padding: 0 16px 0 6px;
  color: ${C.accentOrange};
  font-size: 16px;
  font-weight: 600;
`;
export const ServiceAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: ${C.avatarBg};
  border: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const ServiceRemove = styled.button`
  display: inline-flex;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  img {
    width: 20px;
    height: 20px;
  }
`;

export const AddServicesBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  align-self: flex-start;
  height: 48px;
  background: #fff;
  border: 1px dashed ${C.accentOrange};
  border-radius: 11px;
  padding: 0 16px;
  color: ${C.accentOrange};
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  &:active {
    opacity: 0.7;
  }
  img {
    width: 18px;
    height: 18px;
  }
`;

export const NoteInput = styled.textarea`
  width: 100%;
  min-height: 40px;
  resize: vertical;
  background: #fff;
  border: 1px dashed ${C.dashedBorder};
  border-radius: 10px;
  padding: 10px 12px;
  color: ${C.navy};
  font-size: 14px;
  font-family: inherit;
  &::placeholder {
    color: ${C.placeholder};
  }
  &:focus {
    outline: none;
    border-color: ${C.accentOrange};
  }
`;
